exports.f = require('./_wks');



//////////////////
// WEBPACK FOOTER
// ./~/.store/core-js@2.6.12/~/core-js/modules/_wks-ext.js
// module id = 376
// module chunks = 75